/**
 * Zod schemas for Celery sync job status responses from /api/sync/status/.
 */

import { z } from 'zod';

const SyncJobSchema = z.object({
  id: z.string(),
  stage: z.string(),
  status: z.enum(['idle', 'running', 'done', 'failed', 'skipped']),
  started_at: z.string().nullable(),
  completed_at: z.string().nullable(),
  error: z.string().nullable(),
  updated_at: z.string(),
});

export type SyncJob = z.infer<typeof SyncJobSchema>;

export const SyncStatusResponseSchema = z.object({
  jobs: z.array(SyncJobSchema),
  lastUpdated: z.string(),
});

export type SyncStatusResponse = z.infer<typeof SyncStatusResponseSchema>;
